export default {"src":"/apac/_next/static/media/alfa-aesar.9e6a37a6.svg","height":17,"width":100,"blurWidth":0,"blurHeight":0};